import { Link } from "react-router-dom";
import { FiAlertTriangle, FiHome } from "react-icons/fi";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 text-white px-4">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <FiAlertTriangle className="text-violet-600 text-7xl animate-pulse" />
        </div>

        <h1 className="text-6xl font-extrabold mb-2">404</h1>
        <h2 className="text-2xl font-semibold mb-4">
          Página no encontrada
        </h2>

        <p className="text-slate-300 mb-8">
          La página que buscas no existe o fue movida.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl
                    bg-violet-600
                    text-white font-semibold
                    hover:bg-violet-400 transition"
        >
          <FiHome />
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
